// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dMHoC","expireSoon":"styles_expireSoon__3tvN0"};